'use strict';

var cjs = {};

exports.__exports = cjs;
//# sourceMappingURL=index3.cjs.map
